import { Injectable } from "@angular/core"
import { MatDialog } from "@angular/material/dialog"
import { TrDeleteModalComponent } from "./delete-modal/delete-modal.component"
import { DeleteModalData } from "./delete-modal/delete-modal.model"
import { TrLoadingModalComponent } from "./loading-modal/loading-modal.component"
import { LoadingModalData } from "./loading-modal/loading-modal.model"

@Injectable({ providedIn: "root" })
export class TrModalService {
  constructor(public dialog: MatDialog) {}
  public async showLoadingModal<T = any>(options: LoadingModalData): Promise<void> {
    const dialogRef = this.dialog.open(TrLoadingModalComponent, {
      height: "200px",
      width: "500px",
      disableClose: true,
      hasBackdrop: true,
      panelClass: "tr-loading-modal",
      data: options,
    })

    await dialogRef.afterClosed().toPromise()
  }

  public async showDeleteModal(data: DeleteModalData, loadingMessage?: string): Promise<void> {
    const dialogRef = this.dialog.open(TrDeleteModalComponent, {
      width: data.width || "500px",
      height: data.height,
      panelClass: "tr-delete-modal",
      data,
    })

    const shouldDelete = await dialogRef.afterClosed().toPromise()
    if (shouldDelete) {
      if (loadingMessage) {
        await this.showLoadingModal({
          title: loadingMessage,
          onOpen: async () => data.onDelete(),
        })
      } else {
        await data.onDelete()
      }
    }
  }
}
